import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import appConfig from '../../consumingApi/services/appConfig';
import LogisticService from '@LogisticService';


const BASE_URL = appConfig.logisticsUrl;
const REDUCER_NAME = 'inventoryAuditSlice';
const GET_Inventory_AUDIT_TABLE_DATA = 'inventoryAuditSlice/getInventoryAuditTableData';
const GET_Inventory_AUDIT_IMAGE = 'inventoryAuditSlice/getInventoryAuditImage';

const initialState = {
    getInventoryAuditTableData: [],
    getInventoryAuditTableDataStatus: 'idle',
    getInventoryAuditTableDataStatusError: 'idle',
    getInventoryAuditImage: null,
    getInventoryAuditImageStatus: 'idle',
    getInventoryAuditImageStatusError: 'idle',
};

export const getInventoryAudit = createAsyncThunk(GET_Inventory_AUDIT_TABLE_DATA, async ({ data_inicial, data_final }, { rejectWithValue }) => {
    try {
        const res = await LogisticService.requestWithAuth(`${BASE_URL}/ferramentas/auditoria_inventario/${data_inicial}/${data_final}`);
        return res.data;
    } catch (err) {
        return rejectWithValue(err.response?.data);
    }
});

export const getInventoryAuditImageContent = createAsyncThunk(GET_Inventory_AUDIT_IMAGE, async ({ serial_photo }, { rejectWithValue }) => {
    try {
        const res = await LogisticService.requestWithAuth(`${BASE_URL}/ferramentas/auditoria_inventario_detalhes_foto/${serial_photo}`);
        return res.data;
    } catch (err) {
        return rejectWithValue(err.response?.data);
    }
});

export const inventoryAuditSlice = createSlice({
    name: REDUCER_NAME,
    initialState,
    reducers: {
        resetInventoryAuditImageStatus: (state) => {
            state.getInventoryAuditImageStatus = 'idle';
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getInventoryAudit.pending, (state) => {
                state.getInventoryAuditTableDataStatus = 'pending';
                state.getInventoryAuditTableDataStatusError = null;
            })
            .addCase(getInventoryAudit.fulfilled, (state, action) => {
                state.getInventoryAuditTableData = action.payload;
                state.getInventoryAuditTableDataStatus = 'fulfilled';
            })
            .addCase(getInventoryAudit.rejected, (state, action) => {
                state.getInventoryAuditTableDataStatusError = 'rejected';
                state.getInventoryAuditTableDataStatus = 'rejected';
            })
            .addCase(getInventoryAuditImageContent.pending, (state) => {
                state.getInventoryAuditImageStatus = 'pending';
                state.getInventoryAuditImageStatusError = null;
            })
            .addCase(getInventoryAuditImageContent.fulfilled, (state, action) => {
                state.getInventoryAuditImage = action.payload;
                state.getInventoryAuditImageStatus = 'fulfilled';
            })
            .addCase(getInventoryAuditImageContent.rejected, (state, action) => {
                state.getInventoryAuditImage = null
                state.getInventoryAuditImageStatusError = 'rejected';
                state.getInventoryAuditImageStatus = 'rejected';
            });
    },
});

export const { resetInventoryAuditImageStatus } = inventoryAuditSlice.actions;

export const inventoryAuditSelector = (state) => state.inventoryAuditSlice;

export default inventoryAuditSlice.reducer;
